export const historyGoBackState = 'goback'

export const historyGoBackFromConfirmState = 'gobackconfirmed'
export const historyIgnoreGoBackFromConfirmState = 'ignoregobackconfirmed'
export const historyGoBackFromInsuranceClaimState = 'gobackinsuranceclaim'
export const historyGoToInsuranceClaimSummaryState = 'gotoinsuranceclaimsummary'
